<template>
    <div>
        <menu-bar/>

        <div class="container" role="main" v-if="contratos">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"> <i class="fa fa-home" aria-hidden="true"></i>INICIAL</a></li>
                    <li class="active"><i class="fa fa-id-card-o" aria-hidden="true"></i> VLANS</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <menu-vlan/>
                    </div>
                    <div class="col-md-9">

                        <div class="row">
                            <div class="col-md-7">
                                <label class="control-label">BUSCA POR NOME DO VLAN</label>
                                <input type="text" v-model="nome" class="form-control">
                            </div>

                            <div class="col-md-5">
                                <br/>
                                <blockquote class="blockquote-reverse">
                                    Total de Vlans: <b>{{ getContratos.length }}</b>
                                </blockquote>
                            </div>

                            <div class="col-md-12" style="margin-top: 20px">

                                <table id="mytable" class="table table-bordred table-striped">

                                    <thead>
                                        <tr>
                                            <th style="text-align: center;width: 100px">NÚMERO</th>
                                            <th>NOME</th>
                                            <th style="text-align: center;width: 100px">AÇÕES</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr v-for="r in getContratos" v-bind:key="r._id">
                                            <td style="text-align: center">{{r.numero}}</td>
                                            <td style="vertical-align: middle; text-transform: uppercase">{{ r.nome }}</td>
                                            <td style="text-align: center">
                                                <a :href="'#/vlan/' + r._id" class="btn btn-primary btn-xs">
                                                    ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                                </a>
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuVlan from "../../menus/vlans";
import { Vlan } from "../../class/vlans";

export default {
    components: {
        MenuVlan
    },
    data() {
        return {
            contratos: null,
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos.list;
            }

            return this.contratos.list.filter(player => {
                return player.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    },
    methods: {
        async load() {
            this.contratos = await Vlan.all();
        }
    }
};
</script>
